import { useCallback } from "react";

import { apiClient } from "../../lib/api";

import type { ApiPayload } from "common/classes/api-payload";
import type { Dispatch, SetStateAction } from "react";

import type { User } from "../../types";

export function useUpdateProfile(
  setUser: Dispatch<SetStateAction<User | null>>,
): (firstName: string, lastName: string) => Promise<ApiPayload> {
  const updateProfile = useCallback(
    async (firstName: string, lastName: string): Promise<ApiPayload> => {
      const response = await apiClient.updateProfile({ firstName, lastName });

      if (!response.success) {
        throw new Error(response.message ?? `unexpectedError`);
      }

      setUser((prev) => (prev ? { ...prev, firstName, lastName } : prev));
      return response;
    },
    [setUser],
  );

  return updateProfile;
}
